const updateProfilePayload = values => {
  const payload = {
    PersonId: values.PersonId,
    Name: {
      Prefix: values.Prefix ? values.Prefix : '',
      First: values.First,
      Middle: values.Middle ? values.Middle : '',
      Last: values.Last,
      Suffix: values.Suffix ? values.Suffix : '',
      Informal: values.Informal ? values.Informal : '',
      PreviousWebUserName: values.Name.PreviousWebUserName,
      WebUserName: values.Name.WebUserName,
      PreviousLogonId: values.Name.PreviousLogonId,
      LogonId: values.Name.PreviousLogonId,
      FullName: values.Name.PreviousLogonId,
    },
    WebTypeCode: values.WebTypeCode,
    WebType: values.WebType,
    WebAccess: values.WebAccess,
    WebAccessCode: values.WebAccessCode,
    WebAccessGroupType: values.WebAccessGroupType,
    IsEmployee: values.IsEmployee,
    Title: values.Title,
    Company: values.Company,
    Office: {
      StreetAddress1: values.StreetAddress1,
      StreetAddress2: values.StreetAddress2 ? values.StreetAddress2 : '',
      City: values.City,
      StateCode: values.StateCode,
      PostalCode: values.PostalCode,
      CountryCode: values.CountryCode,
      Country: values.Country ? values.Country : '',
      State: values.OfficeStateOther,
    },
    PoBox: {
      Number: values.PoBoxNumber ? values.PoBoxNumber : '',
      City: values.PoBoxCity ? values.PoBoxCity : '',
      StateCode: values.PoBoxStateCode ? values.PoBoxStateCode : '',
      PostalCode: values.PoBoxPostalCode ? values.PoBoxPostalCode : '',
      State: values.PoBoxOther,
    },
    Phone: {
      Number: values.Number,
      Extension: values.Extension ? values.Extension : '',
    },
    Mobile: values.Mobile ? values.Mobile : '',
    FaxNumber: values.FaxNumber ? values.FaxNumber : '',
    EmailAddress: values.EmailAddress,
    ConfirmEmailAddress: values.ConfirmEmailAddress,
    Spouse: values.Spouse ? values.Spouse : '',
    HomeAddress: values.Spouse ? values.Spouse : '',
    HomePhone: values.Spouse ? values.Spouse : '',
    Assistant: {
      Name: values.AssistantName ? values.AssistantName : '',
      Title: values.AssistantTitle ? values.AssistantTitle : '',
      Phone: values.AssistantPhone ? values.AssistantPhone : '',
      EmailAddress: values.AssistantEmail ? values.AssistantEmail : '',
    },
    DigestScopeId: values.DigestScopeId,
    DigestScopeDescription: values.DigestScopeDescription,
    DigestFormatId: values.DigestFormatId,
    DigestFormatDescription: values.DigestFormatDescription,
    SecurityInformation: values.SecurityInformation,
    GeneralPublications: values.GeneralPublications,
    StatePublications: {
      States: values.StatePublications.States,
      Titles: values.StatePublications.Titles,
    },
    PaperPublications: values.PaperPublications,
    CompliAssistCharts: values.CompliAssistCharts,
    Committees: values.Committees,
    ContactLists: values.ContactLists,
    TemporaryLists: values.ContactLists,
    Comments: values.Comments,
  };
  return payload;
};
export default updateProfilePayload;
